module.exports = __webpack_public_path__ + "img/home-btn-cashout.649a5caa.svg";